import React from "react";
import { PageWrapper } from "components/pages";
import { Dashboard } from "features/Dashboard";
import ImagePageWrapper from "components/pages/ImagePageWrapper";
import { useDispatch, useSelector } from "react-redux";
import { getAuthClaim } from "@redriver/cinnamon";

const DashboardPage = () => {
  const name = useSelector((s) => getAuthClaim(s, "userName"));
  return (
    <ImagePageWrapper title={name || "Home"}>
      <Dashboard />
    </ImagePageWrapper>
  );
};

export default DashboardPage;
